module.exports = __webpack_public_path__ + "static/media/history_10.69967372.jpg";